module.exports = __webpack_public_path__ + "static/media/top-question-banner-wide.9fe3fb40.svg";